import { InputFieldData, InputStateProps } from '../../@types/input-field-data';
import TextInput from './text-input';

export interface EmailInputProps extends InputStateProps, InputFieldData {
  type: 'email';
}

/** A component for rendering an input to collect the user's email address. */
function EmailInput(props: EmailInputProps) {
  return (
    <TextInput
      {...props}
      maxLength={40}
      name={props.name || 'email'}
      text={props.text || 'Email'}
      type="email"
    />
  );
}

export default EmailInput;
